import React from 'react';
import {Layout, Typography, Button} from 'antd';
import {useNavigate} from 'react-router-dom';
import Header from "../../../components/molecules/Header/component";
import {useIsMobile} from '../../../utils/helpers';
import Footer from "../../../components/molecules/Footer/component";

const {Content} = Layout;
const {Title, Paragraph} = Typography;

const RefundsPage: React.FC = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    return (
        <div>
            <Header/>
            <Content style={{maxWidth: 900, margin: '0 auto', padding: '32px 16px 48px'}}>
                <article>
                    <header>
                        <Title level={2}>Refunds & Billing Disputes</Title>
                        <Paragraph>
                            We aim to be fair and transparent. Below is our refunds policy and the steps to request a
                            refund or dispute a charge.
                        </Paragraph>
                    </header>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Subscription refunds</Title>
                        <Paragraph>
                            New accounts receive a one-month free trial. After the trial ends, subscription charges are
                            processed immediately for the selected billing period. We generally do not issue refunds for
                            partial billing periods after the trial, except in exceptional circumstances (e.g. technical
                            issues that prevented access to the service).
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Campaign funding & advertiser refunds</Title>
                        <Paragraph>
                            Campaign funds are used to pay for verified clicks. If you believe clicks were incorrectly
                            validated or charged, contact support and provide the campaign ID, affected dates, and
                            supporting evidence. We will investigate and, where appropriate, apply credits or refunds.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>How to request a refund or dispute a charge</Title>
                        <Paragraph>
                            1. Email <a href="mailto:info@promotifyai.com">info@promotifyai.com</a> with:
                        </Paragraph>
                        <Paragraph>
                            • Your account email or user name<br/>
                            • The transaction or invoice ID<br/>
                            • The reason for the request and any supporting screenshots or logs
                        </Paragraph>
                        <Paragraph>
                            2. We will acknowledge receipt within 1 business day and aim to complete an initial review
                            within 5 business days. Complex investigations may take longer; we will keep you informed.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Chargebacks</Title>
                        <Paragraph>
                            If you open a chargeback with your card issuer, we will cooperate with the bank’s dispute
                            process and provide evidence where required. Note that chargebacks may affect your account
                            standing and can lead to temporary holds while the dispute is resolved.
                        </Paragraph>
                    </section>

                    <section style={{marginTop: 20}}>
                        <Title level={3}>Exceptions</Title>
                        <Paragraph>
                            Refunds may be granted at Promotify’s discretion for technical failures, duplicated charges,
                            or verified platform issues. We do not grant refunds for user error, changes of mind after a
                            trial has ended, or where terms and usage policies have been violated.
                        </Paragraph>
                    </section>

                    <footer
                        style={{
                            marginTop: 28,
                            display: 'flex',
                            gap: 8,
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: isMobile ? 'stretch' : 'flex-end'
                        }}
                    >
                        <Button
                            type="default"
                            onClick={() => navigate('/contact')}
                            block={isMobile}
                            style={{width: isMobile ? '100%' : 'auto'}}
                        >
                            Contact support
                        </Button>
                    </footer>
                </article>
            </Content>
            <Footer/>
        </div>
    );
};

export default RefundsPage;